import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchParentOptions } from "./FetchOptions";

export const getOurMilestonesDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  milestoneOverview: [
    {
      fieldName: "Order Sequence",
      fieldValue: "order_sequence",
      className: "col-span-6",
      type: "text",
      name: "order_sequence",
      formType: "number",
      label: "Order Sequence",
      placeholder: "Enter Order Sequence",
      validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title ",
      validation: { required: "Milestone Title  is required" },
    },

    {
      fieldName: " Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Upload Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      label: "Publish",
      formType: "checkbox",
      placeholder: "Check to publish",
    },
  ],

 milestoneLinks: [
  {
      fieldName: "Order Sequence",
      fieldValue: "field_achievement_order_sequence",
      className: "col-span-6",
      type: "text",
      name: "field_achievement_order_sequence",
      formType: "number",
      label: "Order Sequence",
      placeholder: "Enter Order Sequence",
      validation: { required: "Order Sequence is required" },
    },
  {
    fieldName: "Link Text",
    fieldValue: "field_text",
    className: "col-span-6",
    type: "text",
    name: "field_text",
    formType: "input",
    label: "Link Text",
    placeholder: "Enter Link Text",
    validation: { required: "Link Text  is required" },
  },
  
  {
    fieldName: "Link URL",
    fieldValue: "field_link",
    className: "col-span-6",
    type: "text",
    name: "field_link",
    formType: "input",
    label: "Link URL",
    placeholder: "Enter link (e.g. /calendar or https://example.com)",
    validation: { required: "Link URL is required" },
  },
  {
    fieldName: "Parent Milestone",
    fieldValue: "parent_title",
    className: "col-span-6",
    type: "select",
    name: "parent_title",
    formType: "select",
    label: "Parent Milestone",
    placeholder: "Select a Milestone",
    loadOptions:fetchParentOptions,
    validation: { required: "Parent Milestone is required" },
  },
  {
    fieldName: "Published",
    fieldValue: "published",
    className: "col-span-12",
    type: "checkbox",
    name: "published",
    label: "Published",
    formType: "checkbox",
    placeholder: "Check to publish",
  },
],

};
